import { FileSyncOutlined } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import { RcFile } from "antd/lib/upload";
import { nanoid } from "nanoid";
import { useState } from "react";
import { IFileUploadInstance, ImportFileUpload } from "../../controls/ImportFileUpload";
import { PageTitle } from "../../controls/PageTitle";
import { PageWrapper } from "../../controls/PageWrapper";
import { domain } from "../../domain/domain";
import { strContains } from "../../domain/helpers/tsHelper";
import { IModelInfo } from "../../domain/ModelInfos/IModelInfo";
import { ParserId } from "../../domain/Parsers/IParser";

export function ImportPage() {
    const [fileUpload, setFileUpload] = useState<IFileUploadInstance>();

    function readFile(file: RcFile): Promise<string> {
        const reader = new FileReader();
        reader.readAsText(file);
        return new Promise((resolve, reject) => {
            reader.onload = () => resolve(String(reader.result));
            reader.onerror = (e) => reject(e);
        });
    }

    async function parseFilesClick() {
        const files = fileUpload?.getFiles() || [];

        const parsers = domain.parserService.getParsers();
        const csharpParser = parsers.find(x => x.id === ParserId.Csharp);
        const typescriptParser = parsers.find(x => x.id === ParserId.Typescript);
        const sqlParser = parsers.find(x => x.id === ParserId.Sql);

        let importedModels: IModelInfo[] = [];
        for (const file of files) {
            const fileText = await readFile(file.originFileObj!);

            let fileModels: IModelInfo[] | undefined = undefined;
            if (strContains(file.name, ".json")) {
                fileModels = Array.from(JSON.parse(fileText));
            } else if (strContains(file.name, ".ts")) {
                fileModels = typescriptParser?.parseChunk(fileText);
            } else if (strContains(file.name, ".sql")) {
                fileModels = sqlParser?.parseChunk(fileText);
            } else {
                fileModels = csharpParser?.parseChunk(fileText);
            }
            if (fileModels) {
                importedModels = [...importedModels, ...fileModels];
            }
        }

        // fill possibly missing fields
        importedModels = importedModels.filter(x => x?.name).map(x => {
            x.id = x?.id ?? nanoid();
            x.created = x?.created ?? new Date();
            x.members = x?.members ?? [];
            x.members = x.members.map(y => {
                y.type = y.type ?? {};
                return y;
            });
            return x;
        })

        fileUpload?.clearFiles();

        // console.log("importedModels", importedModels);
        Modal.success({
            content: `imported ${importedModels.length} models`,
        });
        domain.modelInfoService.save(importedModels);
    }

    return (
        <PageWrapper>
            <PageTitle title="Import" />
            <div style={{ padding: 24, minHeight: 360, backgroundColor: "#fff" }}>
                <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                    <ImportFileUpload onInstance={setFileUpload} />
                    <Button type="primary" title="Parse C#, TS, SQL or (exported) JSON files" icon={<FileSyncOutlined />} onClick={parseFilesClick}>Parse C#, TS, SQL or (exported) JSON files</Button>
                </Space>
            </div>
        </PageWrapper>
    );
};


